import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { AiToolConsentDecision } from '@domain/ai-assistant/ai-assistant.models';

import { ButtonComponent } from '@shared/components/button';

@Component({
  selector: 'app-ai-consent-buttons',
  imports: [ButtonComponent],
  templateUrl: './ai-consent-buttons.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col' },
})
export class AiConsentButtonsComponent {
  public disabled = input(false);
  public decided = output<AiToolConsentDecision>();

  public onAllow(): void {
    this.decided.emit('ALLOW');
  }

  public onDeny(): void {
    this.decided.emit('DENY');
  }
}
